import { queryOptions } from '@tanstack/react-query';
import { cityApi, gridApi } from './city-api';

export const cityKeys = {
  all: ['cities'] as const,
  list: () => ['cities', 'list'] as const,
  grid: (cityId: string) => ['cities', 'grid', cityId] as const,
  multipliers: (cityId: string) => ['cities', 'grid', cityId, 'multipliers'] as const,
};

export const cityQueries = {
  list: () => queryOptions({ queryKey: cityKeys.list(), queryFn: () => cityApi.list() }),
  grid: (cityId: string) =>
    queryOptions({
      queryKey: cityKeys.grid(cityId),
      queryFn: () => gridApi.values(cityId),
    }),
  multipliers: (cityId: string) =>
    queryOptions({
      queryKey: cityKeys.multipliers(cityId),
      queryFn: () => gridApi.multipliers(cityId),
    }),
};
